<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="11">
        <v-form ref="queryForm">
          <v-row>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.outboundNum"
                            label="出库单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector label="出库类型"
                                 hide-details="auto"
                                 v-model="queryRequest.outboundType"
                                 source="DicSelector"
                                 param="DELIVERY_TYPE"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.relatedOrderNo"
                            label="关联工单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.contractNo"
                            label="合同号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector label="审核状态"
                                 hide-details="auto"
                                 @keydown.enter="queryPageReset"
                                 v-model="queryRequest.state"
                                 source="DicSelector"
                                 param="AUDIT_STATUS"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector label="去向"
                                 hide-details="auto"
                                 multiple
                                 v-model="queryRequest.outboundDirection"
                                 source="CompanyDicSelector"
                                 param="MATERIAL_DESTINATION"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            label="领用人"
                            @keydown.enter="queryPageReset"
                            hide-details="auto"
                            v-model="queryRequest.employer"/>
            </v-col>

            <v-col cols="2" class="pb-0">
              <z-select-day
                  :hide-details="'auto'"
                  label="期望到达"
                  :startDateRules="[]"
                  :endDateRules="[]"
                  clearable
                  v-model="queryRequest.expectedDate"/>
            </v-col>

            <v-col cols="2" class="pb-0">
              <z-select-day
                  :hide-details="'auto'"
                  label="锁定"
                  :startDateRules="[]"
                  :endDateRules="[]"
                  clearable
                  v-model="queryRequest.lockedDate"/>
            </v-col>

            <v-col cols="2" class="pb-0">
              <z-source-selector label="货运方式"
                                 v-model="queryRequest.freightMethod"
                                 source="DicSelector"
                                 param="DELIVERY_TYPE"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  label="出库物料"
                  @keydown.enter="queryPageReset"
                  prepend-inner-icon="search"
                  hide-details="auto"
                  clearable
                  v-model="queryRequest.materialsInfo"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search"
                            hide-details="auto"
                            clearable
                            label="使用设备产品编号"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.relatedMaterielProdNo"/>
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-col cols="2" class="d-flex justify-start pb-0 ma-0">
              <v-switch
                      class="ma-0"
                      v-model="queryRequest.isReversed"
                      @change="queryPageReset"
                      label="是否红冲"
              ></v-switch>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector v-if="!wmsMngFlag"
                                 v-model="queryRequest.aimsWarehouseId"
                                 hide-details="auto"
                                 multiple
                                 source="WarehouseSelector"
                                 label="仓库"/>
              <z-source-selector v-else
                                 v-model="queryRequest.aimsWarehouseId"
                                 hide-details="auto"
                                 multiple
                                 source="WareHouseWmsManagerSelector"
                                 label="仓库"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                      label="采购申请单号"
                      @keydown.enter="queryPageReset"
                      prepend-inner-icon="search"
                      hide-details="auto"
                      clearable
                      v-model="queryRequest.purchaseApplyNo"/>
            </v-col>
            <v-col cols="6" class="d-flex justify-end pb-0">
              <v-badge
                  :content="querySelected"
                  :value="querySelected!=0"
                  color="green"
                  overlap
              >
                <v-btn small color="primary"
                       @click="queryPageReset">
                  搜索
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
              </v-badge>

              <v-btn color="primary" small
                     class="ml-2"
                     @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn color="primary" small class="ml-2"
                     @click="addOutApply">
                添加出库申请
              </v-btn>
            </v-col>
          </v-row>

        </v-form>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
            :headers="headers"
            :items="list"
            disable-sort
            single-expand
            show-expand
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            :server-items-length="total"
            :loading="loading"
            :footer-props="footerOptions"
            :search="search">
          <!--          <template v-slot:top v-if="!wmsMngFlag">-->
          <!--            <v-toolbar flat>-->
          <!--              <v-spacer></v-spacer>-->
          <!--              <v-btn color="primary" small @click="addOutApply">-->
          <!--                添加出库申请-->
          <!--              </v-btn>-->
          <!--            </v-toolbar>-->
          <!--          </template>-->

          <template v-slot:item.materialsInfo="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                                    <span @click="showMaterInfos(item)"
                                          class="d-inline-block text-truncate"
                                          style="cursor: pointer;color: blue;max-width: 150px;"
                                          v-bind="attrs"
                                          v-on="on">
                                         {{ item.materialsInfo }}
                                    </span>
              </template>
              <span>{{ item.materialsInfo }}</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div style="padding:10px 0;">
                <span>科室</span>：
                <span>{{ item.deptName }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备名称</span>：
                <span>{{ item.eqpName }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备品牌</span>：
                <span>{{ item.eqpBrand }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>使用设备型号</span>：
                <span>{{ item.eqpModel }}</span>
              </div>
              <!--              <div style="padding:10px 0;">-->
              <!--                <span>出厂序列号</span>：-->
              <!--                <span>{{ item.factSerialNo }}</span>-->
              <!--              </div>-->
              <div style="padding:10px 0;">
                <span>使用设备产品编号</span>：
                <span>{{ item.relatedMaterielProdNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>申请人</span>：
                <span>{{ item.applicant }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>申请时间</span>：
                <span>{{ item.createDateTime }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>审核人</span>：
                <span>{{ item.auditPerson }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>审核时间</span>：
                <span>{{ item.auditDate }}</span>
              </div>
              <div v-if="item.refuseReason!=null" style="padding:10px 0;">
                <span>审核建议</span>：
                <span>{{ item.refuseReason }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>出库操作人</span>：
                <span>{{ item.outboundPerson }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>出库时间</span>：
                <span>{{ item.outboundDate }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>出库仓库</span>：
                <span>{{ item.aimsWarehouseListString }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>去向仓库</span>：
                <span>{{ item.outboundDirectionDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>货运方式</span>：
                <span>{{ item.freightMethod }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>运货单号</span>：
                <span>{{ item.waybillNumber }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>采购申请单号</span>：
                <span>{{ item.purchaseApplyNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>运货包装</span>：
                <span>{{ item.waybillPackagingDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>更新时间</span>：
                <span>{{ item.lstupdDateTime }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>图片附件</span>：
                <v-row style="width: 98%;">
                  <v-col cols="4"
                         v-for="(itemImg,index) in item.imgInfoList"
                         :key="index">
                    <v-img :src="itemImg"
                           @click="showImg(itemImg)"
                           aspect-ratio="1.7"
                           contain></v-img>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn v-show="item.state === '01'" small color="primary" width="83px"
                   @click="audit(item)">
              审核
            </v-btn>
            <v-btn v-show="item.state === '02'" small color="primary" width="83px"
                   @click="delivery(item)">
              出库发货
            </v-btn>
            <v-btn v-show="item.state === '04'" small color="error"
                   @click="reApply(item)">
              重新申请
            </v-btn>
            <v-btn small color="secondary" width="83px" style="margin-left:  10px"
                   @click="reportOpen(item)">
              核验单
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--出库申请-->
    <v-dialog v-model="dialog.addWind" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">出库申请</span>
        </v-card-title>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">填写出库信息</v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="e1 > 2" step="2">选择出库物料</v-stepper-step>
            <v-divider/>
            <v-stepper-step step="3">提交出库包</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-5">
                <v-form ref="addForm1" v-model="addForm1Valid">
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span><span style="color: red;">*</span>出库类型: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <z-source-selector source="DicSelector" label="请选择"
                                         param="DELIVERY_TYPE_1"
                                         v-model="addRequest.outboundType"
                                         :rules="[v => !!v || '出库类型必输']" required/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>期望到达日期: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-menu
                          ref="menu3"
                          v-model="menu3"
                          :close-on-content-click="false"
                          :return-value.sync="addRequest.expectedDate"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="addRequest.expectedDate"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="addRequest.expectedDate"
                                       :allowed-dates="expectedAllowedDates"
                                       no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu3 = false">取消</v-btn>
                          <v-btn text color="primary"
                                 @click="$refs.menu3.save(addRequest.expectedDate)">确定
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>合同号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入合同号" v-model="addRequest.contractNo"/>
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>领用人：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入领用人" v-model="addRequest.employer"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span style="color: red;">*</span><span>出库去向：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <z-source-selector source="CompanyDicSelector" label="请选择"
                                         param="MATERIAL_DESTINATION"
                                         v-model="addRequest.outboundDirection"
                                         :rules="[v => !!v || '出库去向必输']"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>科室：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入科室" v-model="addRequest.deptName"/>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex">
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>关联工单：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入关联工单" v-model="addRequest.relatedOrderNo"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span style="color: red;">*</span><span>申请人：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="申请人"
                                    clearable
                                    :rules="[v => !!v || '申请人必输']"
                                    v-model="addRequest.applicant"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>采购申请单号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="采购申请单号"
                                    clearable
                                    v-model="addRequest.purchaseApplyNo"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span> 图片附件: </span>
                    </v-col>
                    <v-col cols="5" class="pt-0 pl-0" style="display: flex">
                      <div style="position: absolute;color: rgba(0, 0, 0, 0.6);font-size: .875rem">只能上传.jpg文件，且不超过2MB，最多上传5张</div>
                      <v-file-input
                          v-if="addRequest.imgFile&&addRequest.imgFile.length<5"
                          v-model="imgFile"
                          accept="image/jpeg, image/jpg"
                          placeholder="Pick an avatar"
                          @change="uploadImgFile"
                          :loading="uploadIsImgLoading"
                          prepend-icon="mdi-camera"
                          :hide-input="true"
                          style="flex:none"
                      ></v-file-input>
                      <template v-for="(item,index) in addRequest.imgFile">
                        <div :key="item+index" style="position: relative;margin-top: 20px">
                          <img style="width: 200px;height: 200px;margin: 5px;cursor: pointer;"
                               :src="item.url" @click="showImg(item.url)" :key="item.key" class="img-show">
                          <button type="button"  @click="deleteImg(index)" aria-label="clear icon" class="v-icon notranslate v-icon--link mdi mdi-close theme--light img-close"></button>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex">
                    <v-col cols="2" class="pt-6 pr-0">
                      <v-btn width="100px" color="primary"
                             @click="baseEqpInfoDialog = !baseEqpInfoDialog">获取基础数据
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>使用设备型号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备型号" v-model="addRequest.eqpModel"
                                    :disabled="true"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>使用设备名称：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备名称" v-model="addRequest.eqpName"
                                    :disabled="true"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>使用设备品牌：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备品牌" v-model="addRequest.eqpBrand"
                                    :disabled="true"/>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex">
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>使用设备出厂序列号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备出厂序列号" v-model="addRequest.factSerialNo"/>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
              <v-card class="mt-5 d-flex justify-center">
                <v-btn color="primary" @click="dialog.addWind=false">
                  取消
                </v-btn>
                <v-btn color="primary" @click="check2" class="ml-15" :disabled="!addForm1Valid">
                  下一步
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card>
                <v-form ref="queryMaterForm">
                  <v-row justify="center">
                    <v-toolbar flat>
                      请选择出库物料：
                      <v-spacer></v-spacer>
                      <v-btn color="primary"
                             class="ma-2">
                        已选定({{ materInfoList.length }}个)
                      </v-btn>
                    </v-toolbar>
                  </v-row>
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="2" class="pt-0 pl-0">
                      <z-source-selector v-if="!wmsMngFlag" source="WarehouseSelector" label="仓库"
                                         param=""
                                         v-model="queryMaterialsRequest.warehouseId"
                                         hide-details="auto">/
                      </z-source-selector>
                      <z-source-selector v-else source="WareHouseWmsManagerSelector" label="仓库"
                                         param=""
                                         v-model="queryMaterialsRequest.warehouseId"
                                         hide-details="auto">/
                      </z-source-selector>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <v-text-field prepend-inner-icon="search" label="库位"
                                    v-model="queryMaterialsRequest.storageLocation"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <v-text-field prepend-inner-icon="search" label="物料名称"
                                    v-model="queryMaterialsRequest.materielName"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <v-text-field prepend-inner-icon="search" label="品牌"
                                    v-model="queryMaterialsRequest.materielBrand"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="3">
                      <v-btn color="primary" :loading="loading" @click="queryMaterials()">
                        搜索
                        <v-icon right>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn color="primary"
                             class="ma-2"
                             @click="resetMaterQuery">
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on"
                                 icon
                                 color="primary"
                                 @click="extendMater">
                            <v-icon v-if="!seniorMaterQueryFlag" large>
                              mdi-arrow-down-drop-circle
                            </v-icon>
                            <v-icon v-else large>mdi-arrow-up-drop-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>高级搜索按钮</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-expand-transition>
                    <div v-show="seniorMaterQueryFlag" style="padding: 15px;">
                      <v-row justify="center" class="d-flex justify-center">
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="型号"
                                        v-model="queryMaterialsRequest.materielModel"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="规格"
                                        v-model="queryMaterialsRequest.specification"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <z-source-selector source="DicSelector" label="物料状态"
                                             param="MATERIAL_STATUS"
                                             v-model="queryMaterialsRequest.state"
                                             hide-details="auto">/
                          </z-source-selector>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="出厂序列号"
                                        v-model="queryMaterialsRequest.factSerialNo"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <z-source-selector source="DicSelector" label="业务标签"
                                             param="BUSINESS_TAG"
                                             v-model="queryMaterialsRequest.businessLabel"
                                             hide-details="auto">/
                          </z-source-selector>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="物料库存编码"
                                        v-model="queryMaterialsRequest.materielId"
                                        hide-details="auto"/>
                        </v-col>
                      </v-row>
                      <v-row justify="center" class="d-flex justify-center">
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="物料产品编号"
                                        v-model="queryMaterialsRequest.materielProdNo"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="物料品类"
                                        v-model="queryMaterialsRequest.category"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="子类"
                                        v-model="queryMaterialsRequest.subType"
                                        hide-details="auto"/>
                        </v-col>
                        <v-col cols="2" class="pt-0 pl-0">
                          <v-text-field prepend-inner-icon="search" label="备注"
                                        v-model="queryMaterialsRequest.remark"
                                        hide-details="auto"/>
                        </v-col>

                        <v-col cols="4" class="d-flex justify-space-between">
                                                    <span style="width: 110px;" class="d-flex align-center">
                                                        库存数量：
                                                     </span>
                          <v-text-field dense clearable
                                        v-model="queryMaterialsRequest.quantityMin"/>
                          <span class="d-flex align-center">~</span>
                          <v-text-field dense clearable
                                        v-model="queryMaterialsRequest.quantityMax"/>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="4" class="d-flex justify-space-between">
                                                    <span style="width: 110px;" class="d-flex align-center">
                                                        预订数量：
                                                     </span>
                          <v-text-field dense clearable
                                        v-model="queryMaterialsRequest.lockedNumMin"/>
                          <span class="d-flex align-center">~</span>
                          <v-text-field dense clearable
                                        v-model="queryMaterialsRequest.lockedNumMax"/>
                        </v-col>
                      </v-row>
                    </div>
                  </v-expand-transition>
                  <v-row class="d-flex justify-center">
                    <v-data-table
                        style="width: 98%;"
                        :options.sync="materOptions"
                        :page.sync="queryMaterialsRequest.pagedQueryInfo.index"
                        :server-items-length="materTotal"
                        v-model="materInfoList"
                        :headers="materHeaders"
                        :items="materList"
                        item-key="id"
                        :single-select="false"
                        show-select
                        disable-sort
                        :footer-props="footerOptions"
                        class="elevation-1">
                      <template v-slot:item.specification="{ item }">
                        {{
                          (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                          + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                        }}
                      </template>
                      <template v-slot:item.withdrawalFlag="{ item }">
                        {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                      </template>
                      <template v-slot:item.applyNumMax="{ item }">
                        {{ item.quantity - item.lockedNum }}
                      </template>
                    </v-data-table>
                  </v-row>
                </v-form>
              </v-card>

              <v-card class="mt-5 d-flex justify-center">
                <v-btn color="primary" @click="e1 = 1">
                  上一步
                </v-btn>

                <v-btn color="primary" @click="checke3" class="ml-15"
                       :disabled="materInfoList.length===0">
                  下一步
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card>
                <v-form ref="addForm3" v-model="addForm3Valid">
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span><span style="color: red;">*</span>出库类型: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <z-source-selector source="DicSelector" label="请选择"
                                         param="DELIVERY_TYPE"
                                         v-model="addRequest.outboundType"
                                         :isDisabled="true"
                                         :rules="[v => !!v || '出库类型必输']">/
                      </z-source-selector>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>期望到达日期: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请选择日期" v-model="addRequest.expectedDate"
                                    :disabled="true"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>合同号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入合同号" v-model="addRequest.contractNo"
                                    :disabled="true"/>
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>领用人：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入领用人" v-model="addRequest.employer"
                                    :disabled="true"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span style="color: red;">*</span><span>出库去向：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <z-source-selector source="CompanyDicSelector" label="请选择"
                                         param="MATERIAL_DESTINATION"
                                         v-model="addRequest.outboundDirection"
                                         :rules="[v => !!v || '出库去向必输']"
                                         hide-details="auto"
                                         :isDisabled="true"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>科室：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入科室" v-model="addRequest.deptName"
                                    :disabled="true"/>
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>关联工单：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入关联工单" v-model="addRequest.relatedOrderNo"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span style="color: red;">*</span><span>申请人：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="" v-model="addRequest.applicant"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>使用设备名称：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备名称" v-model="addRequest.eqpName"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>使用设备型号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备型号" v-model="addRequest.eqpModel"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>使用设备品牌：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备品牌" v-model="addRequest.eqpBrand"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0 ">
                      <span>使用设备出厂序列号：</span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="请输入设备出厂序列号" v-model="addRequest.factSerialNo"
                                    :disabled="true"
                                    hide-details="auto"/>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex justify-center">
                    <v-data-table
                        style="width: 100%;"
                        :headers="checkMaterHeaders"
                        :items="materInfoList"
                        :server-items-length="materInfoList.length"
                        hide-default-footer
                        disable-sort>
                      <template v-slot:item.specification="{ item }">
                        {{
                          (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                          + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                        }}
                      </template>
                      <template v-slot:item.withdrawalFlag="{ item }">
                        {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                      </template>
                      <template v-slot:item.applyNumMax="{ item }">
                        {{ item.quantity - item.lockedNum }}
                      </template>
                      <template v-slot:item.applyNum="{ item }">
                        <v-text-field id="applyNumId" max-width="20px"
                                      v-model="item.applyNum"
                                      :rules="[
                                                                  v => !!v || '申请数量必输',
                                                                  v =>  (!!v && v<= (item.quantity-item.lockedNum)) || '申请出库数量超过最大限制',
                                                                  v =>  (!!v && v> 0) || '申请出库数量必须大于0',
                                                              ]"
                        />
                      </template>
                    </v-data-table>
                  </v-row>

                  <v-row justify="center">
                    <v-toolbar flat>
                      <v-spacer></v-spacer>

                      <span style="color: red;">请确认各物料<span style="color: blue;">申请出库数量</span>，一旦提交无法修改！</span>

                    </v-toolbar>
                  </v-row>

                </v-form>
              </v-card>

              <v-card class="mt-5 d-flex justify-center">
                <v-btn color="primary" @click="e1 = 2">
                  上一步
                </v-btn>
                <v-btn color="primary" class="ml-15" @click="handleOutApply" :loading="outApplyLoading"
                       :disabled="!addForm3Valid">
                  提交
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imgDialog">
      <v-card>
        <v-img :src="imgUrl"></v-img>
      </v-card>
    </v-dialog>
    <!--出库申请审核-->
    <v-dialog v-model="dialog.auditWind" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">出库申请审核</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row justify="center" class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span><span style="color: red;">*</span>出库类型: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector source="DicSelector" label="请选择"
                                     param="DELIVERY_TYPE"
                                     v-model="auditRequest.outboundType"
                                     :isDisabled="true"
                                     :rules="[v => !!v || '出库类型必输']">/
                  </z-source-selector>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>期望到达日期: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请选择日期" v-model="auditRequest.expectedDate"
                                :disabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>合同号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入合同号" v-model="auditRequest.contractNo"
                                :disabled="true"/>
                </v-col>
              </v-row>
              <v-row justify="center" class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>领用人：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入领用人" v-model="auditRequest.employer"
                                :disabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span style="color: red;">*</span><span>出库去向：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector source="CompanyDicSelector" label="请选择"
                                     param="MATERIAL_DESTINATION"
                                     v-model="auditRequest.outboundDirection"
                                     :rules="[v => !!v || '出库去向必输']"
                                     hide-details="auto"
                                     :isDisabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>科室：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入科室" v-model="auditRequest.deptName"
                                :disabled="true"/>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>关联工单：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入关联工单" v-model="auditRequest.relatedOrderNo"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red;">*</span><span>申请人：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="" v-model="auditRequest.applicant"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>使用设备名称：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备名称" v-model="auditRequest.eqpName"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>使用设备型号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备型号" v-model="auditRequest.eqpModel"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>

                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>使用设备品牌：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备品牌" v-model="auditRequest.eqpBrand"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>使用设备出厂序列号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备出厂序列号" v-model="auditRequest.factSerialNo"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
              </v-row>
              <!--              <v-row class="d-flex">-->
              <!--                -->
              <!--              </v-row>-->
              <v-row>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>审核建议：</span>
                </v-col>
                <v-col class="pt-0 pl-0">
                  <v-textarea
                          counter
                          auto-grow
                          :rules="[v => (!!v && v.length < 256) || '拒绝时审核建议不能为空,最多不能超过256字']"
                          row-height="5"
                          label="审核建议"
                          v-model="auditRequest.refuseReason"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-data-table
                    style="width: 100%;"
                    :headers="selectedMaterHeaders"
                    :items="auditRequest.materialInfoList"
                    :server-items-length="auditRequest.materialInfoList.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-row>

            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-2" width="100px" @click="handleAuditRefuse" dark>
            拒绝
          </v-btn>
          <v-btn color="blue darken-1" width="100px" @click="handleAuditPass" :loading="auditPassLoading"
                 dark>
            同意
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog.reportDialog" max-width="1400px">
      <div style="background-color: white" class="pa-0">
        <v-row
                class="mb-3"
                no-gutters>
          <v-col cols="5" class="mt-3">
            <v-btn class="ml-1 mr-1" small color="black" @click="workSheetPrint" outlined dark>
              <v-icon>print</v-icon>
              打印
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="getPdf('#pdfDom1','出库核验单')" dark>
              <v-icon>save_alt</v-icon>
              下载
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="dialog.reportDialog = !dialog.reportDialog" dark>
              <v-icon>close</v-icon>
              关闭
            </v-btn>
            <br>
          </v-col>
        </v-row>
        <section ref="print" class="">
          <div id="pdfDom"  class="work-sheet pb-7" style="line-height: 30px;">
            <h2 style="text-align: center">出库核验单</h2>
            <v-row no-gutters>
              <v-col cols="6">
              </v-col>
              <v-col>
                <div style="float: right; display: table">
                  <img :src="base64LogoImg" style="width: 90px;height: 30px; display: table-cell"/>
                  <span
                          v-if="reportData.serviceHotline && reportData.serviceHotline.length > 0">全国服务热线：{{
                      reportData.serviceHotline
                    }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <b>基础信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>出库单号：</span>{{ reportData.outboundNum }}
              </v-col>
              <v-col cols="4">
                <span>出库类型：</span>{{ reportData.outboundTypeDesc }}
              </v-col>
              <v-col cols="4">
                <span>期望到达日期：</span>{{ reportData.expectedDate }}
              </v-col>
              <v-col cols="4">
                <span>合同号：</span>{{ reportData.contractNo }}
              </v-col>
              <v-col cols="4">
                <span>申请人：</span> {{ reportData.applicant }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>使用去向</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>领用人：</span>{{ reportData.employer }}
              </v-col>
              <v-col cols="4">
                <span>出库去向：</span>{{ reportData.outboundDirectionDesc }}
              </v-col>
              <v-col cols="4">
                <span>使用科室：</span>{{ reportData.deptName }}
              </v-col>
              <v-col cols="4">
                <span>使用设备：</span>{{ reportData.eqpName }}
              </v-col>
              <v-col cols="4">
                <span>设备品牌：</span> {{ reportData.eqpBrand }}
              </v-col>
              <v-col cols="4">
                <span>设备型号：</span>{{ reportData.eqpModel }}
              </v-col>
              <v-col cols="4">
                <span>设备序列号：</span>{{ reportData.factSerialNo }}
              </v-col>
              <v-col cols="4">
                <span>关联工单：</span>{{ reportData.relatedOrderNo }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row  no-gutters>
              <b>出库物料信息</b>
            </v-row>
            <v-row>
              <table class="work-sheet-table" center border="0" cellpadding="0" cellspacing="0" >
                <tr>
                  <td class="text-center">物料产品编号</td>
                  <td class="text-center">仓库</td>
                  <td class="text-center">库位</td>
                  <td class="text-center">采购申请单号</td>
                  <td class="text-center">物料名称</td>
                  <td class="text-center">品牌</td>
                  <td class="text-center">型号</td>
                  <td class="text-center">规格</td>
                  <td class="text-center">品类</td>
                  <td class="text-center">子类</td>
                  <td class="text-center">出厂序列号</td>
                  <td class="text-center">状态</td>
                  <td class="text-center">出库数量</td>
                  <td class="text-center">单价</td>
                  <td class="text-center">单价(不含税)</td>
                  <td class="text-center">税率</td>
                  <td class="text-center">计量单位</td>
                  <td class="text-center">业务标签</td>
                  <td class="text-center">退库件标志</td>
                </tr>
                <tr v-for="(item,index) in reportData.materialInfoList" :key="index"
                    class="text-center">
                  <td>{{ item.materielProdNo }}</td>
                  <td>{{ item.warehouseName }}</td>
                  <td>{{ item.storageLocation }}</td>
                  <td>{{ item.purchaseApplyNo }}</td>
                  <td>{{ item.materielName }}</td>
                  <td>{{ item.materielBrand }}</td>
                  <td>{{ item.materielModel }}</td>
                  <td>{{ item.specificationAll }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.subType }}</td>
                  <td>{{ item.factSerialNo }}</td>
                  <td>{{ item.stateDesc }}</td>
                  <td>{{ item.applyNum }}</td>
                  <td>{{ item.unitPrice }}</td>
                  <td>{{ item.noTaxUnitPrice }}</td>
                  <td>{{ item.taxRate }}</td>
                  <td>{{ item.unit }}</td>
                  <td>{{ item.businessLabelDesc }}</td>
                  <td>{{ item.withdrawalFlag ? '需退库' : '不需要退库' }}</td>
                </tr>
              </table>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters class="mt-3">
              <v-col cols="1" class="pt-3 pr-0">
                <b>备注</b>
              </v-col>
              <v-col cols="8" class="pt-3 pl-0">
                {{ reportData.refuseReason }}
              </v-col>
            </v-row>
          </div>
        </section>

        <section class="printCopy" style="width: 1400px;position: absolute;top: -10px;opacity: 0;z-index: -1">
          <div id="pdfDom1"  class="work-sheet pb-7" style="line-height: 30px; font-size: 20px;">
            <h2 style="text-align: center">出库核验单</h2>
            <v-row no-gutters>
              <v-col cols="6">
              </v-col>
              <v-col>
                <div style="float: right; display: table">
                  <img :src="base64LogoImg" style="width: 90px;height: 30px; display: table-cell"/>
                  <span
                          v-if="reportData.serviceHotline && reportData.serviceHotline.length > 0">全国服务热线：{{
                      reportData.serviceHotline
                    }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <b>基础信息</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>出库单号：</span>{{ reportData.outboundNum }}
              </v-col>
              <v-col cols="4">
                <span>出库类型：</span>{{ reportData.outboundTypeDesc }}
              </v-col>
              <v-col cols="4">
                <span>期望到达日期：</span>{{ reportData.expectedDate }}
              </v-col>
              <v-col cols="4">
                <span>合同号：</span>{{ reportData.contractNo }}
              </v-col>
              <v-col cols="4">
                <span>申请人：</span> {{ reportData.applicant }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters>
              <b>使用去向</b>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <span>领用人：</span>{{ reportData.employer }}
              </v-col>
              <v-col cols="4">
                <span>出库去向：</span>{{ reportData.outboundDirectionDesc }}
              </v-col>
              <v-col cols="4">
                <span>使用科室：</span>{{ reportData.deptName }}
              </v-col>
              <v-col cols="4">
                <span>使用设备：</span>{{ reportData.eqpName }}
              </v-col>
              <v-col cols="4">
                <span>设备品牌：</span> {{ reportData.eqpBrand }}
              </v-col>
              <v-col cols="4">
                <span>设备型号：</span>{{ reportData.eqpModel }}
              </v-col>
              <v-col cols="4">
                <span>设备序列号：</span>{{ reportData.factSerialNo }}
              </v-col>
              <v-col cols="4">
                <span>关联工单：</span>{{ reportData.relatedOrderNo }}
              </v-col>
            </v-row>
            <hr class="my-5">
            <v-row  no-gutters>
              <b>出库物料信息</b>
            </v-row>
            <v-row>
              <table class="work-sheet-table" center border="0" cellpadding="0" cellspacing="0" style="font-size: 18px;">
                <tr>
                  <td class="text-center">物料产品编号</td>
                  <td class="text-center">仓库</td>
                  <td class="text-center">库位</td>
                  <td class="text-center">采购申请单号</td>
                  <td class="text-center">物料名称</td>
                  <td class="text-center">品牌</td>
                  <td class="text-center">型号</td>
                  <td class="text-center">规格</td>
                  <td class="text-center">品类</td>
                  <td class="text-center">子类</td>
                  <td class="text-center">出厂序列号</td>
                  <td class="text-center">状态</td>
                  <td class="text-center">出库数量</td>
                  <td class="text-center">计量单位</td>
                  <td class="text-center">业务标签</td>
                  <td class="text-center">退库件标志</td>
                </tr>
                <tr v-for="(item,index) in reportData.materialInfoList" :key="index"
                    class="text-center">
                  <td>{{ item.materielProdNo }}</td>
                  <td>{{ item.warehouseName }}</td>
                  <td>{{ item.storageLocation }}</td>
                  <td>{{ item.purchaseApplyNo }}</td>
                  <td>{{ item.materielName }}</td>
                  <td>{{ item.materielBrand }}</td>
                  <td>{{ item.materielModel }}</td>
                  <td>{{ item.specificationAll }}
                  <td>{{ item.category }}</td>
                  <td>{{ item.subType }}</td>
                  <td>{{ item.factSerialNo }}</td>
                  <td>{{ item.stateDesc }}</td>
                  <td>{{ item.applyNum }}</td>
                  <td>{{ item.unit }}</td>
                  <td>{{ item.businessLabelDesc }}</td>
                  <td>{{ item.withdrawalFlag ? '需退库' : '不需要退库' }}</td>
                </tr>
              </table>
            </v-row>
            <hr class="my-5">
            <v-row no-gutters class="mt-3">
              <v-col cols="1" class="pt-3 pr-0">
                <b>备注</b>
              </v-col>
              <v-col cols="8" class="pt-3 pl-0">
                {{ reportData.refuseReason }}
              </v-col>
            </v-row>
          </div>
        </section>
      </div>
    </v-dialog>

    <!------------------------------------------ 入库拒绝 ----------------------------------------->
    <v-dialog v-model="dialog.auditRefunseWind" max-width="400px">
      <v-card>
        <v-form
            v-model="auditRefunseFormValid"
            ref="auditRefunseForm">
          <v-card-title>
            <span class="headline">拒绝出库申请</span>
          </v-card-title>
          <v-textarea
              counter="100"
              :rules="[v => (!!v && v.length <= 100) || '最多不能超过100字']"
              v-model="auditRequest.refuseReason"
              color="teal"
              class="ma-5"
              outlined
              hide-detail="true"
              label="请输入拒绝原因">
          </v-textarea>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" width="100px" @click="dialog.auditRefunseWind = false" dark>取消</v-btn>
          <v-btn color="primary" width="100px" :disabled="!auditRefunseFormValid"
                 :loading="auditRefuseLoading"
                 @click="handleAuditRefuse">
            确认
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--出库办理-->
    <v-dialog v-model="dialog.updWind" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">出库发货办理</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row justify="center" class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span><span style="color: red;">*</span>出库类型: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector source="DicSelector" label="请选择"
                                     param="DELIVERY_TYPE"
                                     v-model="auditRequest.outboundType"
                                     :isDisabled="true"
                                     :rules="[v => !!v || '出库类型必输']">/
                  </z-source-selector>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>期望到达日期: </span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请选择日期" v-model="updRequest.expectedDate"
                                :disabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>合同号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入合同号" v-model="updRequest.contractNo"
                                :disabled="true"/>
                </v-col>
              </v-row>
              <v-row justify="center" class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>领用人：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入领用人" v-model="updRequest.employer"
                                :disabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span style="color: red;">*</span><span>出库去向：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <z-source-selector source="CompanyDicSelector" label="请选择"
                                     param="MATERIAL_DESTINATION"
                                     v-model="updRequest.outboundDirection"
                                     :rules="[v => !!v || '出库去向必输']"
                                     hide-details="auto"
                                     :isDisabled="true"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>科室：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入科室" v-model="updRequest.deptName"
                                :disabled="true"/>
                </v-col>
              </v-row>
              <v-row justify="center" class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>关联工单：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入关联工单" v-model="updRequest.relatedOrderNo"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span style="color: red;">*</span><span>申请人：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="" v-model="updRequest.applicant"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>使用设备名称：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备名称" v-model="updRequest.eqpName"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
              </v-row>
              <v-row class="d-flex">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>使用设备型号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备型号" v-model="updRequest.eqpModel"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>使用设备品牌：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备品牌" v-model="updRequest.eqpBrand"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>

                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>使用设备出厂序列号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入设备出厂序列号" v-model="updRequest.factSerialNo"
                                :disabled="true"
                                hide-details="auto"/>
                </v-col>
              </v-row>
              <v-row>
                <v-data-table
                    style="width: 100%;"
                    :headers="selectedMaterHeaders"
                    :items="updRequest.materialInfoList"
                    :server-items-length="updRequest.materialInfoList.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-row>
              <v-row class="d-flex justify-center">
                <v-col cols="1" class="pt-6 pr-0">
                  <span>货运方：</span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <z-source-selector source="DicSelector" label="请选择"
                                     param="FREIGHT_METHOD"
                                     v-model="updRequest.freightMethod"/>
                </v-col>
                <v-col v-if="updRequest.freightMethod==='06'" cols="2" class="pt-0 pl-0">
                  <v-text-field label="请输入货运方" v-model="updRequest.freightMethodDesc"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0">
                  <span>送货单号：</span>
                </v-col>
                <v-col cols="3" class="pt-0 pl-0">
                  <v-text-field label="请输入送货单号/凭证单号" v-model="updRequest.waybillNumber"/>
                </v-col>
                <v-col cols="1" class="pt-6 pr-0 ">
                  <span>送货包装：</span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <z-source-selector source="DicSelector" label="请选择"
                                     param="WAYBILL_PACKAGING"
                                     v-model="updRequest.waybillPackaging"/>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#757575" width="100px" @click="dialog.updWind = false" dark>取消</v-btn>
          <v-btn color="blue darken-1" width="100px" @click="handleUpd" :loading="outOfStockLoading" dark>
            确认出库
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!------------------------------------------ 设备基础数据查询窗口 ----------------------------------------->
    <v-dialog v-model="baseEqpInfoDialog" width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">设备基础数据查询</span>
        </v-card-title>

        <v-card-text>
          <v-row justify="center"
                 class="mb-2"
                 no-gutters>
            <v-col cols="12">
              <v-form ref="queryForm">
                <v-row justify="center">
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpName"
                        prepend-inner-icon="search"
                        label="设备名称"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpBrand"
                        prepend-inner-icon="search"
                        label="设备品牌"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" xs="2" class="pb-0 pr-0">
                    <v-text-field
                        clearable v-model="queryEqpProdRequest.eqpModel"
                        prepend-inner-icon="search"
                        label="设备型号"
                        single-line
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" xs="2" class="pb-0 pr-0">
                    <v-badge
                        :content="eqpInfoQuerySelected"
                        :value="eqpInfoQuerySelected!=0"
                        color="green"
                        overlap
                    >
                      <v-btn :loading="eqpInfoIsSearchLoading"
                             color="primary"
                             @click="eqpInfoQuery">
                        搜索
                      </v-btn>
                    </v-badge>

                    <v-btn color="primary"
                           class="ma-2"
                           @click="resetEqpInfoQuery">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>

                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center">
            <v-col cols="11">
              <v-data-table
                  v-model="eqpInfoSelected"
                  :headers="eqpInfoHeaders"
                  :items="eqpInfoList"
                  disable-sort
                  show-select
                  :single-select="true"
                  :options.sync="options2"
                  :page.sync="queryEqpProdRequest.pagedQueryInfo.index"
                  :footer-props="footerOptions"
                  :server-items-length="eqpInfoTotal">
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" width="100px" @click="getBaseEqpInfo" :disabled="eqpInfoSelected.length==0">
            确认
          </v-btn>
          <v-btn color="error" width="100px" @click="baseEqpInfoDialog = false" dark>取消</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--物料信息-->
    <v-dialog v-model="showMaterFlag" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">物料详细信息</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row>
                <v-data-table
                    style="width: 100%;"
                    :headers="selectedMaterHeaders"
                    :items="tableMaterInfos"
                    :server-items-length="tableMaterInfos.length"
                    hide-default-footer
                    disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                      (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                      + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" width="100px" @click="showMaterFlag = false" dark>关闭</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.isShowToggleUpdReturnDialog" persistent max-width="500">
      <v-card>
        <v-card-title>提示</v-card-title>
        <v-card-text>是否需要修改退库要求</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancelToggle">取消</v-btn>
          <v-btn color="primary" @click="confirmToggle">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-notify ref="notify"></z-notify>
  </v-container>
</template>

<script>
import {
  addOutApply,
  auditPass,
  auditRefuse,
  confirmDelivery,
  pageQuery,
  queryMaterialList,
  checkMtcSeq,
} from '@/api/WarehouseManagement'
import {
  ossUpload,
  queryEqpProdList
} from "@/api/storageApplyInfo";
import {mapGetters} from "vuex"
import {dataChangedCountMixin,dataCatchMixin} from "@/mixin"
import {getBase64} from '@/utils/urlToData'
import reportDownLoad from "@/utils/reportDownLoad"

export default {
  name: "WarehouseManagement",
  mixins: [dataChangedCountMixin,dataCatchMixin],
  computed: {
    ...mapGetters([
      "wmsMngFlag",
      "oaFlag"
    ]),
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 50, 100, 200]
      },
      menu1: false,
      menu2: false,
      menu3: false,
      e1: 1,
      loading: false,
      seniorQueryFlag: false,
      outApplyLoading: false,
      auditPassLoading: false,
      auditRefuseLoading: false,
      outOfStockLoading: false,
      queryRequest: {
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        companyId: "",
        outboundType: "",
        outboundNum: "",
        expectedDate: [],
        relatedOrderNo: "",
        contractNo: "",
        employer: "",
        outboundDirection: [],
        deptName: "",
        relatedMaterielProdNo: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        factSerialNo: "",
        state: "",
        applicantId: "",
        applicant: "",
        materialsInfo: "",
        auditPersonId: "",
        auditPerson: "",
        auditDate: "",
        refuseReason: "",
        outboundPersonId: "",
        outboundPerson: "",
        outboundDateTime: [],
        freightMethod: "",
        waybillNumber: "",
        waybillPackaging: "",
        createDateTime: [],
        lockedDate: [],
        isReversed:false,
      },
      imgDialog:false,
      imgUrl:'',
      uploadIsImgLoading: false,
      imgFile:null,
      addRequest: {
        imgFile:[],
        imgList:[],
        outboundType: "",
        expectedDate: "",
        contractNo: "",
        employer: "",
        outboundDirection: "",
        deptName: "",
        relatedMaterielProdNo: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        factSerialNo: "",
        relatedOrderNo: "",
        materialInfoList: [],
        remark:""
      },
      base64LogoImg:"",
      list: [],
      total: 0,
      options: {},
      search: '',
      headers: [
        {text: '出库单号', value: 'outboundNum', align: 'center'},
        {text: '出库类型', value: 'outboundTypeDesc', align: 'center'},
        {text: '关联工单', value: 'relatedOrderNo', align: 'center'},
        {text: '关联出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '合同号', value: 'contractNo', align: 'center'},
        {text: '关联类型', value: 'relTypeDesc', align: 'center'},
        {text: '去向', value: 'outboundDirectionDesc', align: 'center'},
        {text: '领用人', value: 'employer', align: 'center'},
        {text: '申请日期', value: 'createDateTime', align: 'center'},
        {text: '期望到达日期', value: 'expectedDate', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '出库物料', value: 'materialsInfo', align: 'center', width: 180},
        {text: '操作', value: 'actions', align: 'center',width:200 },
        {text: '', value: 'data-table-expand', align: 'center'},
      ],
      headers1: [
        {text: '出库单号', value: 'outboundNum', align: 'center'},
        {text: '出库类型', value: 'outboundTypeDesc', align: 'center'},
        {text: '关联工单', value: 'relatedOrderNo', align: 'center'},
        {text: '关联出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '合同号', value: 'contractNo', align: 'center'},
        {text: '关联类型', value: 'relTypeDesc', align: 'center'},
        {text: '去向', value: 'outboundDirectionDesc', align: 'center'},
        {text: '领用人', value: 'employer', align: 'center'},
        {text: '申请日期', value: 'createDateTime', align: 'center'},
        {text: '期望到达日期', value: 'expectedDate', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '出库物料', value: 'materialsInfo', align: 'center', width: 200},
        {text: '', value: 'data-table-expand', align: 'center'},
      ],
      dialog: {
        addWind: false,
        auditWind: false,
        auditRefunseWind: false,
        updWind: false,
        isShowToggleUpdReturnDialog: false,
        reportDialog:false,
      },
      //设备
      baseEqpInfoDialog: false,
      queryEqpProdRequest: {
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        compId: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        eqpType: ""
      },
      eqpInfoSelected: [],
      eqpInfoHeaders: [
        {text: '设备产品编号', value: 'id',},
        {text: '设备名称', value: 'eqpName',},
        {text: '设备品牌', value: 'eqpBrand'},
        {text: '设备型号', value: 'eqpModel'},
      ],
      eqpInfoList: [],
      eqpInfoTotal: 0,
      options2: {},
      eqpInfoIsSearchLoading: false,
      eqpInfoQuerySelected: 0,


      auditRefunseFormValid: false,
      addForm1Valid: false,
      addForm3Valid: false,

      //物料
      queryMaterialsRequest: {
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        materielId: "",
        companyId: "",
        warehouseId: "",
        warehouseName: "",
        storageLocation: "",
        materielProdNo: "",
        materielName: "",
        materielBrand: "",
        materielModel: "",
        specification: "",
        specification2: "",
        specification3: "",
        specification4: "",
        accApplicableParts: "",
        factSerialNo: "",
        category: "",
        subType: "",
        withdrawalFlag: undefined,
        supplies: undefined,
        state: "",
        lockedNum: 0,
        quantity: 0,
        unit: "",
        businessLabel: "",
        guarEndDate: "",
        storageNo: "",
        attachedInfo: "",
        remark: "",
        createDateTime: [],
        eqpProdId: "",
        lockedNumMin: undefined,
        lockedNumMax: undefined,
        quantityMin: undefined,
        quantityMax: undefined
      },
      queryMaterialsRequestBak: {
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        materielId: "",
        companyId: "",
        warehouseId: "",
        warehouseName: "",
        storageLocation: "",
        materielProdNo: "",
        materielName: "",
        materielBrand: "",
        materielModel: "",
        specification: "",
        specification2: "",
        specification3: "",
        specification4: "",
        accApplicableParts: "",
        factSerialNo: "",
        category: "",
        subType: "",
        withdrawalFlag: undefined,
        supplies: undefined,
        state: "",
        lockedNum: 0,
        quantity: 0,
        unit: "",
        businessLabel: "",
        guarEndDate: "",
        storageNo: "",
        attachedInfo: "",
        remark: "",
        createDateTime: [],
        eqpProdId: "",
        lockedNumMin: undefined,
        lockedNumMax: undefined,
        quantityMin: undefined,
        quantityMax: undefined
      },
      materLoad: false,
      materList: [],
      materTotal: 0,
      seniorMaterQueryFlag: false,
      materInfoList: [],
      materOptions: {},
      materSearch: '',
      materHeaders: [
        {text: '仓库', value: 'warehouseName', align: 'center'},
        {text: '库位', value: 'storageLocation', align: 'center'},
        {text: '采购申请单号', value: 'purchaseApplyNo', align: 'center',},
        {text: '物料名称', value: 'materielName', align: 'center'},
        {text: '品牌', value: 'materielBrand', align: 'center'},
        {text: '型号', value: 'materielModel', align: 'center'},
        {text: '规格', value: 'specification', align: 'center'},
        {text: '品类', value: 'category', align: 'center'},
        {text: '子类', value: 'subType', align: 'center'},
        {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '库存数量', value: 'quantity', align: 'center'},
        {text: '可申请数量', value: 'applyNumMax', align: 'center', width: 100,},
        {text: '计量单位', value: 'unit', align: 'center'},
        {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
      ],

      //选中物料
      checkMaterHeaders: [
        {text: '仓库', value: 'warehouseName', align: 'center'},
        {text: '库位', value: 'storageLocation', align: 'center'},
        {text: '物料名称', value: 'materielName', align: 'center'},
        {text: '品牌', value: 'materielBrand', align: 'center'},
        {text: '型号', value: 'materielModel', align: 'center'},
        {text: '规格', value: 'specification', align: 'center'},
        {text: '品类', value: 'category', align: 'center'},
        {text: '子类', value: 'subType', align: 'center'},
        {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '可出库数量', value: 'applyNumMax', align: 'center', width: 100,},
        {text: '申请出库数量', value: 'applyNum', align: 'center', width: 100,},
        {text: '计量单位', value: 'unit', align: 'center'},
        {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        {text: '退库件标志', value: 'withdrawalFlag', align: 'center'},
      ],

      //选中物料
      selectedMaterHeaders: [
        {text: '物料产品编号', value: 'materielProdNo', align: 'center'},
        {text: '物料唯一编码', value: 'materielId', align: 'center'},
        {text: '仓库', value: 'warehouseName', align: 'center'},
        {text: '库位', value: 'storageLocation', align: 'center'},
        {text: '采购申请单号', value: 'purchaseApplyNo', align: 'center',},
        {text: '物料名称', value: 'materielName', align: 'center'},
        {text: '品牌', value: 'materielBrand', align: 'center'},
        {text: '型号', value: 'materielModel', align: 'center'},
        {text: '规格', value: 'specification', align: 'center'},
        {text: '品类', value: 'category', align: 'center'},
        {text: '子类', value: 'subType', align: 'center'},
        {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
        {text: '状态', value: 'stateDesc', align: 'center'},
        {text: '申请出库数量', value: 'applyNum', align: 'center', width: 100,},
        {text: '计量单位', value: 'unit', align: 'center'},
        {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        {text: '退库件标志', value: 'withdrawalFlag', align: 'center'},
      ],

      //核验单
      reportData: {
      },
      //审核
      auditRequest: {
        id: '',
        outboundType: "",
        expectedDate: "",
        contractNo: "",
        employer: "",
        outboundDirection: "",
        deptName: "",
        relatedMaterielProdNo: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        factSerialNo: "",
        relatedOrderNo: "",
        materialInfoList: [],
        refuseReason: '',
      },

      //出库办理
      updRequest: {
        id: '',
        outboundType: "",
        expectedDate: "",
        contractNo: "",
        employer: "",
        outboundDirection: "",
        deptName: "",
        relatedMaterielProdNo: "",
        eqpName: "",
        eqpBrand: "",
        eqpModel: "",
        factSerialNo: "",
        relatedOrderNo: "",
        materialInfoList: [],
        refuseReason: '',
        freightMethod: "",
        freightMethodDesc: "",
        waybillNumber: "",
        waybillPackaging: "",
      },

      //物料信息
      showMaterFlag: false,
      tableMaterInfos: [],
    }
  },
  watch: {
    options: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.queryPageQuery()
      },
    },
    materOptions: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryMaterialsRequest.pagedQueryInfo.index = 1
          this.queryMaterialsRequest.pagedQueryInfo.pageSize = 999999
        } else {
          this.queryMaterialsRequest.pagedQueryInfo.index = val.page
          this.queryMaterialsRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }

        this.handleMaterQuery()
      },
    },
    options2: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryEqpProdRequest.pagedQueryInfo.index = 1
          this.queryEqpProdRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryEqpProdRequest.pagedQueryInfo.index = val.page
          this.queryEqpProdRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.eqpInfoQuery()
      }
    }
  },
  methods: {
    workSheetPrint() {
      this.$print(this.$refs.print) // 使用
    },
    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    //分页查询
    queryPageReset() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.queryPageQuery();
    },
    showImg(url){
      this.imgDialog=true;
      this.imgUrl=url;
    },
    deleteImg(index) {
      this.addRequest.imgFile.splice(index, 1);
    },
    //图片上传
    uploadImgFile() {
      if (!this.imgFile) {
        return;
      }
      const isOverSize = this.imgFile.size / 1024 / 1024 < 2;
      if (!isOverSize) {
        this.$refs.notify.show("上传文件大小不能超过2MB", {timeout: 1000, color: 'red lighten-1'});
        return;
      }
      this.uploadIsImgLoading = true;
      var formData = new window.FormData();
      formData.append('file', this.imgFile);
      ossUpload(formData).then(res => {
        this.uploadIsImgLoading = false;
        this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
        // 应该返回url
        this.addRequest.imgFile.push(res);
        this.imgFile=null;
      }).catch(err => {
        this.uploadIsImgLoading = false;
      });
    },
    //重置
    resetQuery() {
      this.$refs.queryForm.reset();
      this.queryPageReset();
    },
    queryPageQuery() {
      this.loading = true;
      pageQuery(this.queryRequest).then(res => {
        this.list = res.list;
        this.total = res.total;
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },


    //添加出库申请
    addOutApply() {
      this.e1 = 1;
      this.dialog.addWind = true;
      // this.$refs.addForm1.reset();
      this.materInfoList = [];
      // this.$refs.addForm3.reset();
    },

    expectedAllowedDates(val) {
      return Date.parse(val) >= Date.now() - 1000 * 60 * 60 * 24;
    },
    lockedAllowedDates(val) {
      return Date.parse(val) < Date.now();
    },

    imgListCheck(){
      if(this.addRequest.imgFile && this.addRequest.imgFile.length>0){
        let imgUrlList=[];
        this.addRequest.imgFile.forEach(item=>{
          imgUrlList.push(item.key)
        })
        this.addRequest.imgList=imgUrlList
      }
    },
    handleOutApply() {
      if (this.materInfoList.length < 1) {
        this.$refs.notify.show("请至少选择一条物料信息", {timeout: 1000, color: 'error'});
      } else {
        this.addRequest.materialInfoList = [];
        this.materInfoList.forEach(item => {
          this.addRequest.materialInfoList.push(item);
        });
        this.outApplyLoading = true;
        this.imgListCheck()
        addOutApply(this.addRequest).then(res => {
          this.dialog.addWind = false;
          this.outApplyLoading = false;
          this.queryPageQuery();
          this.$refs.notify.show("出库申请添加成功", {timeout: 1000, color: 'success'});
        }).catch(err => {
          this.outApplyLoading = false;
        })
      }
    },


    //物料
    queryMaterials() {
      this.queryMaterialsRequest.pagedQueryInfo.index = 1;
      this.handleMaterQuery();
    },

    resetMaterQuery() {
      // this.$refs.queryMaterForm.reset();
      this.queryMaterialsRequest = this.queryMaterialsRequestBak;
      this.queryMaterials();
    },

    handleMaterQuery() {
      this.materLoad = true;
      queryMaterialList(this.queryMaterialsRequest).then(res => {
        this.materList = res.list;
        this.materTotal = res.total;
        this.materLoad = false
      }).catch(err => {
        this.materLoad = false
      })
    },
    extendMater() {
      this.seniorMaterQueryFlag = !this.seniorMaterQueryFlag;
    },

    //入库核验单打开
    reportOpen(item) {
      this.reportData = item;
      this.dialog.reportDialog = true;
      getBase64(this.reportData.logoPath, data => {
        this.base64LogoImg = data
      })},
    //审核
    audit(item) {
      this.auditRequest = item;
      this.dialog.auditWind = true;
      this.$refs.auditForm.resetValidation();
    },

    //审核通过
    handleAuditPass() {
      if((this.auditRequest.refuseReason ==null || this.auditRequest.refuseReason=="") ||
              ((this.auditRequest.refuseReason !=null || this.auditRequest.refuseReason!="") && this.auditRequest.refuseReason.length <=256)){
        this.auditPassLoading = true;
        let req = {
          id: this.auditRequest.id,
          refuseReason: this.auditRequest.refuseReason
        }
        auditPass(req).then(() => {
          this.dialog.auditWind = false;
          this.auditPassLoading = false;
          this.queryPageQuery();
          this.$refs.notify.show("办理成功", {timeout: 1000, color: 'success'});
        }).catch(() => {
          this.auditPassLoading = false;
        });
      }
    },
    //审核拒绝
    handleAuditRefuse() {
      if (this.$refs.auditForm.validate()) {
        this.auditRefuseLoading = true;
        let req = {
          id: this.auditRequest.id,
          refuseReason: this.auditRequest.refuseReason
        }
        auditRefuse(req).then(() => {
          this.dialog.auditRefunseWind = false;
          this.dialog.auditWind = false;
          this.auditRefuseLoading = false;
          this.queryPageQuery();
          this.$refs.notify.show("办理成功", {timeout: 1000, color: 'success'});
        }).catch(() => {
          this.auditRefuseLoading = false;
        });
      }
    },

    //确认出库
    delivery(item) {
      this.updRequest = item;
      this.dialog.updWind = true;
    },
    handleUpd() {
      this.outOfStockLoading = true;
      let req = {
        id: this.updRequest.id,
        freightMethod: this.updRequest.freightMethod,
        otherFreightMethod: this.updRequest.freightMethod === '06' ? this.updRequest.freightMethodDesc : '',
        waybillNumber: this.updRequest.waybillNumber,
        waybillPackaging: this.updRequest.waybillPackaging,
      }
      confirmDelivery(req).then(() => {
        this.outOfStockLoading = false;
        this.dialog.isShowToggleUpdReturnDialog = true;

      }).catch(() => {
        this.outOfStockLoading = false;
      });
    },
    //重新申请
    reApply(item) {
      this.e1 = 1;
      this.addRequest = item;
      this.addRequest.id = '';
      this.materInfoList = [];
      this.dialog.addWind = true;
    },
    //设备基础信息查询
    eqpInfoQuery() {
      this.eqpInfoIsSearchLoading = true
      queryEqpProdList(this.queryEqpProdRequest).then(res => {
        this.eqpInfoList = res.list
        this.eqpInfoTotal = res.total
        this.eqpInfoIsSearchLoading = false
      }).catch(() => {
        this.eqpInfoIsSearchLoading = false
      })
    },
    //获取标准数据
    getBaseEqpInfo() {
      const eqpInfo = this.eqpInfoSelected.pop();
      this.addRequest.eqpModel = eqpInfo.eqpModel;
      this.addRequest.eqpName = eqpInfo.eqpName;
      this.addRequest.eqpBrand = eqpInfo.eqpBrand;
      this.addRequest.relatedMaterielProdNo = eqpInfo.id;
      this.baseEqpInfoDialog = !this.baseEqpInfoDialog;
    },
    resetEqpInfoQuery() {
      Object.assign(this.$data.queryEqpProdRequest, this.$options.data().queryEqpProdRequest)
      this.eqpInfoQuery()
    },

    //物料信息
    showMaterInfos(item) {
      this.tableMaterInfos = item.materialInfoList;
      this.showMaterFlag = true;
    },
    //切换3
    checke3() {
      this.materInfoList.forEach(item => {
        item.applyNum = item.quantity - item.lockedNum;
      });
      this.e1 = 3;
    },
    check2() {
      //校验填入工单
      if (this.addRequest.relatedOrderNo) {
        checkMtcSeq(this.addRequest.relatedOrderNo).then(res => {
          this.handleMaterQuery()
          this.e1 = 2;
        }).catch(err => {
          console.error(err);
        })
      } else {
        this.handleMaterQuery()
        this.e1 = 2;
      }


    },
    //修改
    confirmToggle() {
      this.$router.push({
        path: '/warehouse-out-record?id=' + this.updRequest.id
      });
      this.$store.dispatch('setCurretTitle', '出库记录');
    },
    cancelToggle() {
      this.dialog.updWind = false;
      this.dialog.isShowToggleUpdReturnDialog = false;
      this.queryPageQuery();
      this.$refs.notify.show("办理成功", {timeout: 1000, color: 'success'});
    }

  },
  created() {

  },
  mounted() {
  },
}
</script>

<style scoped>

#applyNumId .v-text-field input {
  text-align: center !important;
}

.work-sheet-table {
  text-align: left;
  width: 100%;
  font-size: 0.9em;
}
.work-sheet {
  padding: 0px 20px;
}
.work-sheet-table tr td {
  padding: 3px;
  padding-left: 10px;
}
.work-sheet-table  td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.img-close{
   position: absolute;
   right: 0;
 }
</style>
